import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  height: "18",
  viewBox: "0 0 18 18",
  width: "18",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "clip-rule": "evenodd",
      d: "m0 8.99984c0 4.97056 4.02944 8.99996 9 8.99996 4.9706 0 9-4.0294 9-8.99996 0-4.95232-3.9999-8.970414-8.94531-8.99984v1.92338c3.88311.02939 7.02201 3.18637 7.02201 7.07646 0 3.90836-3.1684 7.07666-7.0767 7.07666-3.90833 0-7.07666-3.1683-7.07666-7.07666z",
      fill: "#fff",
      "fill-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }